import _ from 'lodash';
import { LoadSaveService } from 'gw-capability-quoteandbind';
import { MLMultiLobsDataHolderService } from 'ml-services-common-react';
import {MLHVQDiscrepanciesUtil} from 'ml-portals-util-js';

const {
    hasDiscrepancies
} = MLHVQDiscrepanciesUtil();

const changeFutureSteps = (steps, changeNextSteps, stepPath) => {
    const index = _.findIndex(
        steps,
        ({ path }) => path === stepPath
    );
    if (index > 0) {
        const remainingSteps = steps.slice(index, steps.length);
        changeNextSteps(remainingSteps);
    }
};

const processPaHVQConsumerAdditionalDriversCheck = async (submissionVM, currentStepName, steps, changeNextSteps) => {
    let nextStepName;
    const hasAdditionalDrivers = submissionVM.lobData.personalAuto.coverables.drivers.value
        .some((driver) => !driver.bridgedFromHVQ_ML);
    if (hasAdditionalDrivers
        && !MLMultiLobsDataHolderService.hasCompletedStep('paHVQConsumerAdditionalDrivers')) {
        nextStepName = 'paHVQConsumerAdditionalDrivers'
        changeFutureSteps(steps, changeNextSteps, '/pa-hvq-additional-drivers');
    } else {
        const firstDefaultFieldsStep = MLMultiLobsDataHolderService.getFirstHVQConsumerNonCompletedStep();
        if (firstDefaultFieldsStep !== 'paHVQConsumerDriverDetails') {
            nextStepName = firstDefaultFieldsStep
            const index = _.findIndex(
                steps,
                ({ mlStepName }) => mlStepName === firstDefaultFieldsStep
            );
            if (index > 0) {
                const remainingSteps = steps.slice(index, steps.length);
                changeNextSteps(remainingSteps);
            }
        } else {
            // paHVQConsumerAPlusAndCLUE;
            _.set(submissionVM, 'portalCurrentStep_ML.value', 'paHVQConsumerAPlusAndCLUE');
            const response = await LoadSaveService.updateDraftSubmission(submissionVM.value)
            submissionVM.value = response;
            nextStepName = 'paHVQConsumerDriverDetails'
            changeFutureSteps(steps, changeNextSteps, '/pa-hvq-driver-details');
        }
    }
    MLMultiLobsDataHolderService.storeFlowSteps(currentStepName, nextStepName);
};

const processPaHVQConsumerDiscrepanciesCheck = async (submissionVM, currentStepName, steps, changeNextSteps) => {
    let nextStepName;
    if (hasDiscrepancies(submissionVM)
            && !MLMultiLobsDataHolderService.hasCompletedStep('paHVQConsumerDiscrepancies')) {
        // paHVQConsumerDiscrepancies
        MLMultiLobsDataHolderService.storeFlowSteps(currentStepName, 'paHVQConsumerDiscrepancies');
        changeFutureSteps(steps, changeNextSteps, '/pa-hvq-consumer-discrepancies')
    } else {
        await processPaHVQConsumerAdditionalDriversCheck(submissionVM, currentStepName, steps, changeNextSteps)
    }
    return nextStepName;
};

export default {
    processPaHVQConsumerAdditionalDriversCheck: processPaHVQConsumerAdditionalDriversCheck,
    processPaHVQConsumerDiscrepanciesCheck: processPaHVQConsumerDiscrepanciesCheck
};